<template>
    <div class="item-hotel" v-if="hotel && isCheckOut">
        <ul>
            <li>
                <div class="has-icon moon-icon d-flex justify-content-between">
                    <div>
                        <p>{{hotelName}}</p>
                    </div>
                    <div class="tools">
                        <button class="btn info" @click="onClickInfo">
                            <div></div>
                        </button>
                    </div>
                </div>
                <div class="info">
                    <p class="font-weight-normal">check-out</p>
                </div>
                <div class="add-transfer">
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {hotelName, isSameDate} from '../../../../utils/helper'

export default {
  name: 'ItemHotelCheckOut',
  props: {
    day: {
      type: Date,
      default: new Date()
    },
    days: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    hotel: function () {
      const list = this.$store.getters.getSelectedHotelsByDay(this.day)
      if (!list) return null
      const found = list.find(item => {
        return isSameDate(this.day, item.period.end)
      })
      return found
    },
    hotelName: function () {
      return hotelName(this.hotel.hotel.location.name)
    },
    isCheckOut: function () {
      return isSameDate(this.day, this.hotel.period.end)
    }
  },
  methods: {
    ...mapGetters(['getSelectedHotels']),
    onClickInfo () {
      this.$emit('detail', this.hotel)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemHotelCheckOut.vue